






































import Vue, { PropType } from "vue";
import { MapDataType } from "@/types";

export default Vue.extend({
  props: {
    mapDataType: { type: String as PropType<MapDataType> }
  },
  data() {
    return {
      mapDataTypes: Object(MapDataType)
    };
  },
  methods: {
    selectMapDataType: function (mapDataType: MapDataType) {
      this.$emit("select-map-data-type", mapDataType);
    }
  }
});
